module.exports = __webpack_public_path__ + "static/media/palm_leaves_05-[Converted]2.58e261cc.png";